import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAnalytics from "vue-analytics";

import VueMoment from 'vue-moment'
import moment from 'moment/moment';
import 'moment/locale/pt-br';

Vue.use(VueMoment, {moment});


// https://blog.logrocket.com/full-guide-to-using-font-awesome-icons-in-vue-js-apps-5574c74d9b2d/
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faCheck,
  faTimes,
  faClock
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faPlus, faCheck, faTimes, faClock);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
Vue.axios.defaults.common = {headers: {'X-Requested-With': 'XMLHttpRequest'}};
Vue.axios.defaults.withCredentials = true;

// if (process.env.NODE_ENV === "production") {
//   Vue.use(VueAnalytics, {
//     id: "UA-1711136-24",
//     router
//   });
// }

Vue.filter("dateToBr", function (value) {
  return value.split('-').reverse().join('/');
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
